import { Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { IDataItem } from "src/types/atoms";
const MessageBar = ({
  label,
  value,
  size = "normal"
}: IDataItem) => {
  const isNormalSize = size === "normal";
  return <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} flexWrap={"wrap"} width={1} bgcolor={grey[200]} borderRadius={isNormalSize ? 4 : 2} paddingY={0.5} paddingX={isNormalSize ? 2 : 1} marginBottom={3}>
      <Typography color={grey[700]} fontWeight={isNormalSize ? 600 : 400}>
        {label}
      </Typography>
      <Typography fontSize={isNormalSize ? "1.2rem" : "1rem"} color={grey[600]} fontWeight={isNormalSize ? 800 : 600}>
        {value}
      </Typography>
    </Stack>;
};
export default MessageBar;